<template>
  <div
    :data-color="activeColor"
    :data-image="backgroundImage"
    :data-background-color="backgroundColor"
    :style="sidebarStyle"
    class="sidebar"
  >
    <div class="logo">
      <router-link :to="defaultRoute" class="simple-text logo-mini">
      
        <!--target="_blank" (removed)-->
        <div>
          <img :src="logo" />
          <!--<img src="img/GlobeChek_EYE.png" />-->
        </div>
        <!--class="logo-img"  (removed) -->
      </router-link>

      <router-link :to="defaultRoute" class="simple-text logo-normal" style="font-size: 17px; font-weight: 400;">
        <template>{{ title }}</template>
      </router-link>

      <div class="navbar-minimize">
        <md-button id="minimizeSidebar" class="md-round md-just-icon md-transparent" @click="minimizeSidebar">
          <i class="material-icons text_align-center visible-on-sidebar-regular">more_vert</i>
          <i class="material-icons design_bullet-list-67 visible-on-sidebar-mini">view_list</i>
        </md-button>
      </div>
    </div>

    <div ref="sidebarScrollArea" class="sidebar-wrapper">
      <slot />

      <md-list class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks" :key="link.name + index" :link="link">
            <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink" />
          </sidebar-item>
        </slot>
      </md-list>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  props: {
    title: {
      type: String,
      default: "GlobeChek"
    },
    activeColor: {
      type: String,
      default: "azure",
      validator: value => {
        let acceptedValues = ["", "purple", "azure", "green", "orange", "danger", "rose"]
        return acceptedValues.indexOf(value) !== -1
      }
    },
    backgroundImage: {
      type: String,
      default: "" // "./img/sidebar-0.jpg"
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: value => {
        let acceptedValues = ["", "black", "white", "red"]
        return acceptedValues.indexOf(value) !== -1
      }
    },
    logo: {
      type: String,
      default: "../../img/GlobeChek_EYE.png"
    },
    brand: {
      type: String,
      default: "./img/GlobeChek.png"
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      defaultRoute: (sessionStorage.getItem('portalRoute') + "/dashboard"),
      publicPath: process.env.BASE_URL
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    }
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`
      }
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false
    }
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    }
  }
}
</script>

<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
